<template>
    <div class="content" v-cloak>
        <div class="content_box tableParent public_box">
            <div class="search_box" v-if="!isPlugDetail">
                <!--检索部分-->
                <el-form :inline="true" :model="navForm">
                    <el-form-item label="车牌号/车架号/设备编号:">
                        <el-input class="width_200" v-model="navForm.condition.search" size="small" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="产品类型:" prop="deviceType" v-if="productTypeData && productTypeData.length > 1">
                        <el-select v-model="navForm.condition.deviceType" placeholder="请选择" size="small" class="width_150" @change="productTypeChange">
                            <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.dictName" :value="item.metaData"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="运营公司:" prop="subTenantId">
                        <el-cascader popper-class="cascaderStyle" ref="companyRef" v-model="navForm.condition.cascaderVal" :options="cascCaderOptions" :props="cascCaderProps" placeholder="请选择" :show-all-levels="false" @change="handleSelectCost" filterable clearable size="small"></el-cascader>
                    </el-form-item>
                    <el-form-item label="告警类型:">
                        <el-select class="width_160" v-model="navForm.condition.alarmType" placeholder="请选择" size="small" clearable filterable>
                            <el-option v-for="(item, index) in alarmOptions" :key="index" :label="item.desc" :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="告警时间:">
                        <el-date-picker class="form_time" v-model="queryTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" @change="queryTimeChange" :picker-options="alarmPickerOptions">
                        </el-date-picker>
                    </el-form-item>
                    <!-- 单摄/双摄 shortTermRental 由前端自动注入 -->
                    <el-form-item label="短租车:" v-if="false">
                        <el-select class="width_120" v-model="navForm.condition.shortTermRental" placeholder="全部" size="small" clearable>
                            <el-option label="全部" :value="null"></el-option>
                            <el-option label="短租车" :value="true"></el-option>
                            <el-option label="非短租车" :value="false"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button class="queryBtn" ref="queryBtnRef" type="primary" size="small" @click="searchTable" style="margin-left: 0.2rem">查询</el-button>
                        <el-button type="success" size="small" @click="handleAlarmDownload" style="margin-left: 0.1rem">导出</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <!--table表格部分-->
            <template v-if="currentType == 1 || currentType == 2">
                <el-table ref="multipleTable" class="tableHeightAdaptive" :data="tableData" v-loading="loading" @sort-change="sortChange">
                    <el-table-column prop="subTenantName" label="所属公司" width="120">
                        <template slot-scope="scope">
                            <overflow-txt :txt="scope.row.companyName"></overflow-txt>
                        </template>
                    </el-table-column>
                    <el-table-column prop="plateNo" label="车牌号" width="110"></el-table-column>
                    <el-table-column prop="deviceNumber" label="设备号" width="120"></el-table-column>
                    <el-table-column prop="vin" label="车架号" width="180"></el-table-column>
                    <el-table-column prop="alarmTypeName" label="告警类型" width="150">
                        <template slot-scope="scope">
                            <overflow-txt :txt="scope.row.alarmTypeName"></overflow-txt>
                        </template>
                    </el-table-column>
                    <el-table-column prop="startTime" label="告警时间" width="190"></el-table-column>
                    <el-table-column prop="alarmSpeed" label="告警速度" width="120">
                        <template slot-scope="scope">
                            <span>{{ String(scope.row.alarmSpeed) != 'null' ? scope.row.alarmSpeed + ' km/h' : '' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="startLocation" label="地址">
                        <template slot-scope="scope">
                            <overflow-txt :txt="scope.row.startLocation"></overflow-txt>
                        </template>
                    </el-table-column>
                    <el-table-column prop="attachmentNum" label="告警内容" width="90">
                        <template slot-scope="scope">
                            <span class="clickTxt" v-if="scope.row.attachmentNum > 0" @click="showAttachment(scope.row)">{{ scope.row.attachmentNum }}</span>
                            <span v-else>{{ scope.row.attachmentNum }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <template v-else>
                <el-table ref="multipleTable" class="tableHeightAdaptive" :data="tableData" v-loading="loading" @sort-change="sortChange">
                    <el-table-column prop="subTenantName" label="所属公司">
                        <template slot-scope="scope">
                            <overflow-txt :txt="scope.row.subTenantName"></overflow-txt>
                        </template>
                    </el-table-column>
                    <el-table-column prop="platNo" label="车牌号"></el-table-column>
                    <el-table-column prop="deviceNumber" label="设备号"></el-table-column>
                    <el-table-column prop="vin" label="车架号"></el-table-column>
                    <el-table-column prop="alarmTypeName" label="告警类型"></el-table-column>
                    <el-table-column prop="alarmTime" label="告警时间"></el-table-column>
                </el-table>
            </template>
            <!--分页部分-->
            <el-pagination style="margin-top: 0.2rem" @current-change="handleCurrentChange" @size-change="handleSizeChange" :current-page="navForm.pageNo" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20]" :page-size="navForm.pageSize" :total="navForm.pageTotal">
            </el-pagination>
        </div>
        <!-- 附件弹窗 -->
        <el-dialog class="attachment_dialog" :visible.sync="dialogVisible" width="1000px" :modal-append-to-body="false">
            <div v-loading="previewLoading">
                <div class="dialog_box" v-if="imgList.length > 0">
                    <div class="dialog_title">
                        <span>{{ attachmentRow.deviceNumber ? attachmentRow.deviceNumber : '--' }}</span>
                        <span class="warning_type">{{ attachmentRow.alarmTypeName ? attachmentRow.alarmTypeName : '--' }}</span>
                        <span>{{ attachmentRow.startTime ? attachmentRow.startTime : '--' }}</span>
                    </div>
                    <div class="attachment_box clearfix">
                        <div class="box_left fl" v-if="dialogVisible">
                            <img-deal ref="imgDeal" :url="currentItem.ossPath" v-if="currentItem.isImg"></img-deal>
                            <video :src="currentItem.ossPath" controls autoplay muted loop v-else></video>
                        </div>
                        <ul class="box_right fr">
                            <li :class="{ subsetActive: activeImgIndex == imgIndex, Img_li: 1 }" v-for="(imgItem, imgIndex) in imgList" :key="imgIndex" @click="previewItem(imgItem, imgIndex)">
                                <img :src="imgItem.ossPath" v-if="imgItem.isImg" />
                                <video :src="currentItem.ossPath" :poster="imgList[0].ossPath" muted v-else></video>
                            </li>
                        </ul>
                    </div>
                </div>
                <el-empty description="暂无数据" v-else></el-empty>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import OSS from 'ali-oss';
import ImgDeal from '@/components/ImgDeal.vue';
let _this;
export default {
    components: {
        ImgDeal
    },
    data() {
        return {
            currentType: 1,
            tmpSource: null,
            OSSClient: null,
            dialogVisible: false,
            previewLoading: true,
            currentItem: '',
            activeImgIndex: 0,
            imgList: [],
            isPlugDetail: false,
            attachmentRow: {
                device: '17716532123',
                totalTripsNum: '侧翻碰撞告警',
                startTime: '2022-11-07 17:09:23'
            },
            tableHeight: window.innerHeight > 760 ? 507 : 342,
            plubHeight: window.innerHeight > 760 ? 507 : 500,
            rid: '',
            loading: false,
            center: { lng: 116.404269, lat: 39.915378 },
            zoom: 18,
            BDmap: '',
            BMap: '',
            batchIdList: [], //车队
            advanceAlarmOptions: [],
            obdAlarmOptions: [],
            alarmOptions: [],
            alarmPickMinDate: null,
            alarmPickerOptions: {
                onPick: ({ minDate, maxDate }) => {
                    this.alarmPickMinDate = minDate;
                    if (maxDate) {
                        this.alarmPickMinDate = null;
                    }
                },
                disabledDate: (time) => {
                    const now = new Date();
                    now.setHours(23, 59, 59, 999);
                    const oneMonthAgo = new Date();
                    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
                    oneMonthAgo.setHours(0, 0, 0, 0);
                    return time.getTime() < oneMonthAgo.getTime() || time.getTime() > now.getTime();
                }
            },
            queryTime: null,
            navForm: {
                condition: {
                    cascaderVal: null,
                    search: null,
                    alarmStatus: null,
                    companyId: null,
                    fleetId: null,
                    alarmType: null,
                    minDuration: null,
                    startTime: null,
                    endTime: null,
                    shortTermRental: null,
                    deviceType: null
                },
                orders: [],
                pageNo: 1,
                pageSize: 10,
                pageTotal: 0
            },
            downloadForm: {
                companyId: null,
                fleetId: null,
                lastPlugginTime: true,
                online: true,
                plugging: true,
                pullNum: true,
                pullNumDateRange: 'week',
                showHasTrip: true,
                showHasTripTimeStartParam: '',
                showHasTripTimeEndParams: ''
            },
            marker: { showFlag: false },
            currentPage: 1, //当前页
            pageSize: 10, //一页多少条数据
            totalPage: 1, //总页数tableData:[],
            tableData: [],
            companyList: [],
            deviceQueryData: {},
            cascCaderProps: {
                children: 'subTenantTreeLists',
                label: 'tenantName',
                value: 'tenantId',
                expandTrigger: 'hover',
                checkStrictly: true
            }
        };
    },
    computed: {
        productTypeData() {
            let typeData = this.$store.state.common.productTypeData;
            if (typeData && typeData.length) {
                let expandItem = typeData.find((item) => item.expandInfo);
                if (this.navForm.condition.deviceType == null) {
                    this.navForm.condition.deviceType = expandItem ? expandItem.metaData : typeData[0].metaData;
                }
            }

            // 产品类型获取告警枚举
            if (this.navForm.condition.deviceType == 1 || this.navForm.condition.deviceType == 2) {
                this.alarmOptions = this.advanceAlarmOptions;
            } else {
                this.alarmOptions = this.obdAlarmOptions;
            }

            return typeData;
        },
        cascCaderOptions() {
            return this.$store.state.common.companyTreeData;
        }
    },
    mounted() {
        _this = this;
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
        this.navForm.companyId = this.userInfo.company;

        // if (this.$route.query && this.$route.query.item) {
        //     let queryData = JSON.parse(this.$route.query.item);
        //     this.setQueryTime(1);
        //     this.navForm.condition.search = queryData.plateNo;
        // } else {
        //     this.setQueryTime(2);
        // }
        // this.queryTime = [`2025-01-22 00:00:00`, `2025-06-09 23:59:59`];
        this.queryTime = this.getLast3DaysRange();
        this.queryTimeChange();

        this.getAdvanceAlarmTypeEnum();
        this.getOBDAlarmTypeEnum();
        this.getData();
        this.getAdvanceAlarmTypeEnum();
    },
    methods: {
        getLast3DaysRange() {
            // 获取今天的日期
            const today = new Date();

            // 计算 T-1 日期（昨天）
            const yesterday = new Date(today);
            yesterday.setDate(today.getDate() - 1);

            // 计算 T-4 日期（3天前）
            const threeDaysAgo = new Date(yesterday);
            threeDaysAgo.setDate(yesterday.getDate() - 3);

            // 格式化日期为 YYYY-MM-DD HH:mm:ss
            const formatDate = (date, isEndOfDay = false) => {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');

                if (isEndOfDay) {
                    return `${year}-${month}-${day} 23:59:59`;
                } else {
                    return `${year}-${month}-${day} 00:00:00`;
                }
            };

            // 生成时间范围数组
            return [
                formatDate(yesterday), // 3天前的开始时间
                formatDate(yesterday, true) // 昨天的结束时间
            ];
        },
        productTypeChange(val) {
            if (this.navForm.condition.deviceType == 1 || this.navForm.condition.deviceType == 2) {
                this.alarmOptions = this.advanceAlarmOptions;
            } else {
                this.alarmOptions = this.obdAlarmOptions;
            }

            this.navForm.condition.alarmType = null;
        },
        getAdvanceAlarmTypeEnum() {
            this.$request({ method: 'get', url: '/ubi/api/enum/getAdvanceAlarmTypeEnum', params: {} }).then((res) => {
                if (res.code == 200) {
                    this.advanceAlarmOptions = res.data;
                }
            });
        },
        getOBDAlarmTypeEnum() {
            this.$request({ method: 'get', url: '/ubi/api/enum/getOBDAlarmTypeEnum', params: {} }).then((res) => {
                if (res.code == 200) {
                    this.obdAlarmOptions = res.data;
                }
            });
        },
        setQueryTime(day) {
            let days = this.getLastNDays(day);

            if (days.length == 1) {
                this.queryTime = [`${days[0]} 00:00:00`, `${days[0]} 23:59:59`];
            } else {
                this.queryTime = [`${days[1]} 00:00:00`, `${days[0]} 23:59:59`];
            }

            this.queryTimeChange();
        },
        getLastNDays(n) {
            const dates = [];

            for (let i = 0; i < n; i++) {
                const currentDate = new Date();
                currentDate.setDate(currentDate.getDate() - i);

                const year = currentDate.getFullYear();
                const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                const day = String(currentDate.getDate()).padStart(2, '0');

                dates.push(`${year}-${month}-${day}`);
            }

            return dates;
        },
        handleSelectCost(val) {
            this.navForm.condition.companyId = val && val.length > 0 ? val[val.length - 1] : null;
            this.$refs.companyRef.dropDownVisible = false;
        },
        // 初始化OSS
        initOSSClient(watchImgData) {
            this.$request({ method: 'get', url: '/ubi/api/aliyun/oss/access' }).then((res) => {
                if (res.code == 200) {
                    this.OSSClient = new OSS({
                        accessKeyId: res.data.accessKeyId,
                        accessKeySecret: res.data.accessKeySecret,
                        stsToken: res.data.securityToken,
                        // region表示您申请OSS服务所在的地域，例如oss-cn-hangzhou。
                        region: res.data.region,
                        bucket: res.data.bucket
                    });
                    // 初始化图片
                    // this.initImgUrl(watchImgData);
                } else {
                    console.log('oss初始化失败，正在重试！');
                    if (this.retryCount <= 200) {
                        setTimeout(() => {
                            this.retryCount++;
                            this.initOSSClient();
                        }, 200);
                    } else {
                        console.log('oss长时间初始化失败！');
                    }
                }
            });
        },
        getAdvanceAlarmTypeEnum() {
            this.$request({ method: 'get', url: '/ubi/api/enum/getAdvanceAlarmTypeEnum' }).then((res) => {
                if (res.code == 200) {
                    this.advanceAlarmOptions = res.data;
                }
            });
        },
        sortChange(column) {
            let tmpIndex = this.navForm.orders.findIndex((res) => {
                return res.column == column.prop;
            });
            let tmpOrderItem = {
                asc: column.order == 'ascending' ? true : false,
                column: column.prop
            };
            this.navForm.orders = [];
            this.navForm.orders.push(tmpOrderItem);
            column.order && this.navForm.orders.push(tmpOrderItem);
            this.getWarningData();
        },
        //重新计算index序号
        hIndex(index) {
            // index索引从零开始，index +1即为当前数据序号
            this.currentPage <= 0 ? (this.currentPage = 1) : this.currentPage;
            // 如果当前不是第一页数据
            if (this.currentPage != 1) {
                // index + 1 + (( 当前页 - 1) * 每页展示条数)
                // 比如是第二页数据 1 + ((2 - 1)*5) = 6,第二页数据也就是从序号6开始
                return index + 1 + (this.currentPage - 1) * this.pageSize;
            }
            // 否则直接返回索引+1作为序号
            return index + 1;
        },
        getData() {
            this.isPlugDetail = this.$route.query.queryForm ? (this.$route.query.isPlugDetail == 'false' ? false : true) : false;
            if (this.$route.query.queryForm) {
                let routeForm = this.$route.query.queryForm;
                this.batchIdList = routeForm.tmpBatchIdList ? routeForm.tmpBatchIdList : this.batchIdList;
                this.navForm.condition.companyId = routeForm.companyId ? routeForm.companyId : this.navForm.condition.companyId;
                this.navForm.condition.fleetId = routeForm.fleetId ? routeForm.fleetId : this.navForm.condition.fleetId;
            }
            this.isPlugDetail = this.$route.query.isPlugDetail == 'true' ? true : false;
            this.getWarningData();
        },
        //点击查询
        searchTable() {
            if (this.tmpSource) {
                this.tmpSource.cancel();
            }
            if (!this.validateAlarmQueryRange()) {
                return;
            }
            this.navForm.pageNo = 1;
            this.getWarningData();
        },
        queryTimeChange() {
            if (this.queryTime) {
                this.navForm.condition.startTime = this.queryTime[0];
                this.navForm.condition.endTime = this.queryTime[1];
            } else {
                this.navForm.condition.startTime = null;
                this.navForm.condition.endTime = null;
            }
        },
        validateAlarmQueryRange() {
            if (!this.queryTime || this.queryTime.length !== 2) {
                return true;
            }

            const startTime = new Date(this.queryTime[0]).getTime();
            const endTime = new Date(this.queryTime[1]).getTime();
            const now = new Date();
            now.setHours(23, 59, 59, 999);
            const oneMonthAgo = new Date();
            oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
            oneMonthAgo.setHours(0, 0, 0, 0);
            const oneMonthAgoTime = oneMonthAgo.getTime();
            const nowTime = now.getTime();

            if (startTime < oneMonthAgoTime || endTime < oneMonthAgoTime || startTime > nowTime || endTime > nowTime) {
                this.$message.warning('告警时间只允许查询当前时间往前一个月内的数据');
                return false;
            }

            return true;
        },
        //获取tbody里的数据
        getWarningData() {
            let _this = this;
            this.loading = true;
            this.tableData = [];

            this.currentType = this.navForm.condition.deviceType;

            let urlStr = this.currentType == 1 || this.currentType == 2 ? '/ubi/api/advance_alarm/page' : '/ubi/api/advanceAlarm/obdPageAlarm';

            let requestData = JSON.parse(JSON.stringify(this.navForm));
            if (requestData.condition.deviceType == 2) {
                requestData.condition.deviceType = 1;
                requestData.condition.shortTermRental = true;
            } else if (requestData.condition.deviceType == 1) {
                requestData.condition.shortTermRental = false;
            }
            this.$request({ method: 'post', url: urlStr, data: requestData }).then((res) => {
                this.loading = false;

                if (res.code == 200) {
                    this.tableData = res.data.list;
                    this.navForm.pageTotal = res.data.total;
                } else {
                    this.navForm.pageTotal = 0;
                }
            });
        },
        // 导出告警
        handleAlarmDownload() {
            if (!this.navForm.condition.startTime || !this.navForm.condition.endTime) {
                this.$message.warning('请先选择告警时间范围');
                return;
            }
            if (!this.validateAlarmQueryRange()) {
                return;
            }
            this.loading = true;
            let downloadUrl, downloadData, downloadName;
            if (this.currentType == 1 || this.currentType == 2) {
                // 双摄/单摄告警下载
                downloadUrl = '/ubi/api/advance_alarm/download';
                let conditionData = JSON.parse(JSON.stringify(this.navForm.condition));
                if (conditionData.deviceType == 2) {
                    conditionData.deviceType = 1;
                    conditionData.shortTermRental = true;
                } else if (conditionData.deviceType == 1) {
                    conditionData.shortTermRental = false;
                }
                downloadData = conditionData;
                downloadName = this.currentType == 2 ? '单摄告警清单.xlsx' : '双摄告警清单.xlsx';
            } else {
                // OBD告警下载
                downloadUrl = '/ubi/api/obd_alarm/download';
                downloadData = this.navForm;
                downloadName = 'OBD告警清单.xlsx';
            }
            this.$download({
                method: 'post',
                url: downloadUrl,
                data: downloadData
            }).then((res) => {
                this.loading = false;
                let nowDate = this.$$dateFormatting(new Date(), 'yyyy年MM月dd日');
                let fileName = this.$$parseFileName(res.headers['content-disposition']) || nowDate + downloadName;
                this.$$exportFile(res.data, fileName);
            }).catch(() => {
                this.loading = false;
            });
        },
        //分页数据多少条change
        handleSizeChange(val) {
            this.navForm.pageSize = val;
            this.getWarningData();
        },
        //分页：当前页改变之后的函数
        handleCurrentChange(val) {
            this.navForm.pageNo = val;
            this.getWarningData();
        },
        showAttachment(attachmentRow) {
            this.initOSSClient();
            this.dialogVisible = true;
            this.attachmentRow = attachmentRow;
            this.getAttachments(attachmentRow);
        },
        previewItem(imgItem, imgIndex) {
            this.activeImgIndex = imgIndex;
            this.currentItem = imgItem;
        },
        getAttachments(rowItem) {
            this.previewLoading = true;
            this.imgList = [];
            let fileTypeList = ['tiff', 'jfif', 'bmp', 'webp', 'gif', 'svg', 'jpg', 'svgz', 'png', 'jpeg', 'ico', 'xbm', 'dib', 'pjp', 'apng', 'tif', 'pjpeg', 'avif'];

            this.$request({ method: 'get', url: '/ubi/api/advance_alarm/attachments', params: { alarmId: rowItem.id } }).then((res) => {
                this.previewLoading = false;
                if (res.code == 200) {
                    this.imgList = res.data;
                    this.imgList.forEach((item) => {
                        item.fileType = item.fileName.split('.').pop();
                        item.isImg = fileTypeList.indexOf(item.fileType) != -1 ? true : false;
                    });
                    this.previewItem(this.imgList[0], 0);
                }
            });
        }
    }
};
</script>
<style lang="less" scoped>
.content {
    position: relative;
    height: 100%;
    .back_btn {
        position: absolute;
        right: 0px;
        top: -5px;
    }
    .search_box {
        margin-bottom: 20px;
        .form_time {
            width: 350px !important;
            padding-right: 0;
        }
        .el-form--inline .el-form-item {
            margin-bottom: 10px;
        }
    }
}

.attachment_dialog {
    /deep/ .el-dialog__body {
        padding-top: 0;
    }
    .dialog_title {
        span {
            color: #333;
            font-size: 16px;
        }
        .warning_type {
            margin: 0 30px;
        }
    }
    .attachment_box {
        height: 550px;
        .box_left {
            width: 780px;
            height: 550px;
            padding-right: 40px;
            border-right: 1px solid #8b8b8b;
            video {
                width: 100%;
                height: 100%;
                // border: 1px solid #ccc;
            }
        }
        .box_right {
            width: 170px;
            height: 550px;
            overflow-y: auto;
            // margin-right: 20px;
            text-align: center;
            padding-left: 25px;
            li {
                width: 120px;
                height: 120px;
                border: 1px solid #ccc;
                margin-bottom: 20px;
                cursor: pointer;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }
                video {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }
            }
            li:last-child {
                margin-bottom: 0;
            }
            .subsetActive {
                border: 2px solid red !important;
            }
        }
    }
}
</style>
